import type { GameFormValues } from '../types'

/** Shown under the Duration field when it is empty or non-positive. */
export const DURATION_REQUIRED_MESSAGE = 'Duration cannot be empty or 0'

/**
 * Client-side validation for the add/edit Game modal.
 *
 * Deliberately narrow: the API stays the source of truth for everything else,
 * and its `invalid_fields` response is what fills the rest of `fieldErrors`.
 * Duration is validated here because an empty or zero value produces an
 * `ends_at` equal to `starts_at`, which the API accepts on some paths -- so
 * there is no server error to surface and the game saves with no length.
 *
 * Returns the same shape `applyGameApiError` writes: form field name → message.
 */
export const validateGameForm = (
  values: GameFormValues
): Record<string, string> => {
  const errors: Record<string, string> = {}

  const duration = values.durationMinutes
  if (duration === null || !Number.isFinite(duration) || duration <= 0) {
    errors.durationMinutes = DURATION_REQUIRED_MESSAGE
  }

  return errors
}
